<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title class="grey1">
    {{ data.sysText.addNewEmployee_header | titlecase }}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="cancel()" [attr.aria-label]="data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <div class="new-employee">
    <div class="sub-employee">
      <div class="new-ee-column">
        <app-input-field
          [label]="data.sysText.firstName"
          [control]="firstName"
          [group]="form"
          [icon]="'person'"
        ></app-input-field>
      </div>
      <div class="new-ee-column">
        <app-input-field
          [label]="data.sysText.middleName"
          [control]="middleName"
          [group]="form"
        ></app-input-field>
      </div>
    </div>
    <div class="sub-employee">
      <div class="new-ee-column">
        <app-input-field
          [label]="data.sysText.lastName"
          [control]="lastName"
          [group]="form"
        ></app-input-field>
      </div>
      <div class="new-ee-column">
        <app-input-field
          [label]="data.sysText.suffix"
          [control]="suffix"
          [group]="form"
        ></app-input-field>
      </div>
    </div>
    <div class="new-ee-full-column">
      <div>
        <app-input-field
          [label]="data.sysText.preferredName"
          [control]="preferredName"
          [group]="form"
        ></app-input-field>
      </div>
    </div>
    @if (data.addNewEmployeeDialog.showCompany) {
      <div class="new-ee-full-column">
        <app-select-field
          [control]="companyId"
          [label]="data.sysText.company"
          [options]="data.addNewEmployeeDialog.companyOptions"
          [icon]="'business'"
          [shouldCapitalize]="false"
        ></app-select-field>
      </div>
    }
    <app-email-field-group
      [group]="form"
      [workEmailControl]="workEmail"
      [isWorkEmailPreferredControl]="isWorkEmailPreferred"
      [personalEmailControl]="personalEmail"
      [isPersonalEmailPreferredControl]="isPersonalEmailPreferred">
    </app-email-field-group>
    <div class="sub-employee">
      <div class="new-ee-column">
        <app-input-field
          [label]="data.sysText.workPhone"
          [control]="workPhone"
          [group]="form"
          [icon]="'phone'"
        ></app-input-field>
      </div>
      <div class="new-ee-column">
        <app-input-field
          [label]="data.sysText.personalPhone"
          [control]="personalPhone"
          [group]="form"
        ></app-input-field>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="cancel()">
      {{ data.sysText.cancel }}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && save(false)">
    {{ data.sysText.submit }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>